module.exports = __webpack_public_path__ + "img/hz_30.05f243b8.jpg";